module.exports = __webpack_public_path__ + "static/media/data_avail.7b2ccc21.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/data_avail.png
// module id = 255
// module chunks = 0